// extracted by mini-css-extract-plugin
module.exports = {"navtab":"ilist_navtab_1Gvzq","active":"ilist_active_18aSz"};